/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Module for Cancelling evnet creation.
 * @module src/components/CreateEditSurgeryEvent/CancelEventCreationModal
 */
import React, { FC } from 'react';
import Modal from '@salesforce/design-system-react/components/modal';
import Button from '@salesforce/design-system-react/components/button';
import Input from '@salesforce/design-system-react/components/input';
import './index.scss';

interface Props {
  showEditConfirmationModal: boolean;
  handleModalToggle: () => void;
  handlelSaveFavoriteModalConfirmPress: () => void;
  handleSaveName: (e: any) => void;
  favName: string;
}

const FavoriteSaveConfirmationModal: FC<Props> = ({
  handleSaveName,
  favName,
  showEditConfirmationModal,
  handleModalToggle,
  handlelSaveFavoriteModalConfirmPress,
}) => {
  const handleName = (e: any): void => {
    handleSaveName(e.target.value);
  };

  return (
    <Modal
      className="save-as-fav-modal default-modal_header default-modal_footer"
      isOpen={showEditConfirmationModal}
      onRequestClose={handleModalToggle}
      ariaHideApp={false}
      footer={[
        <Button label="Cancel" onClick={handleModalToggle} key="no" />,
        <Button
          disabled={!favName}
          label="Save"
          variant="brand"
          onClick={handlelSaveFavoriteModalConfirmPress}
          key="yes"
        />,
      ]}
      heading="Favorite"
    >
      <div style={{ padding: '15px' }}>
        <Input
          aria-describedby="favorite_name"
          id="unique-id-4"
          label="Enter Favorite Name"
          placeholder="Favorite Name"
          value={favName}
          onChange={handleName}
        />
      </div>
    </Modal>
  );
};

/** Custom component for Cancelling evnet creation */
export default FavoriteSaveConfirmationModal;
